<template>
  <div class="livePlayer">
    <div class="pVodWrap live" :class="{ gameMode: gameMode }">
      <div
        class="pVodInner"
        :class="{ hideFilter: !showHideFlag }"
        style="position: relative"
      >
        <div
          class="hiddenPanel"
          @click="iconShowHide"
          :class="{ higher: !showHideFlag }"
        ></div>
        <button class="pipClose" @click="vodClosed">
          {{ this.$t('broadcast.closePip') }}
        </button>
        <div class="topDiv"></div>

        <div
          class="pVodTop"
          :class="{ hide: !showHideFlag || chatFixFlag || chatFocus }"
        >
          <img
            class="logo"
            src="../../assets/img/ico/logo_color.png"
          />
          <img class="live" src="../../assets/img/ico/live_ci.png" />

          <p v-if="gameMode" class="game_noti">
            [{{ this.$t('broadcast.gameMode') }}]
          </p>
        </div>

        <div
          class="brandImg"
          :class="{ hide: !showHideFlag || chatFixFlag || chatFocus }"
        >
          <router-link
            :to="'/Planning/brandList/' + vodInfo.brandSysId"
            @click.native="clickFlag"
          >
            <div
              class="brdImgDiv"
              :style="{
                'background-image': 'url(' + vodInfo.brandImageUrl + ')',
                backgroundSize: 'contain'
              }"
            ></div>
            <div class="rerDiv">
              <img
                class="rerun"
                src="../../assets/img/ico/profile_label_vod.png"
                v-if="vodInfo.broadcastType === 1"
              />
              <img
                class="rerun"
                src="../../assets/img/ico/profile_label_live.png"
                v-if="vodInfo.broadcastType === 0"
              />
            </div>
          </router-link>

          <div class="brandTxt">
            <p class="title">{{ vodInfo.title }}</p>
            <span>{{ vodInfo.brandName }}</span>
            <div class="watchCnt">
              <img src="../../assets/img/ico/icon_live_person.png" />
              <span>{{ roomInfo.viewCnt | makeComma }}</span>
            </div>
            <div class="likeCnt">
              <img src="../../assets/img/ico/icon_live_heart.png" />
              <span>{{ roomInfo.likeCnt | makeComma }}</span>
            </div>
          </div>
        </div>

        <!-- 가위바위보 게임 -->
        <div v-if="gameConfirm" class="gameConfirm">
          <p v-html="$t('broadcast.joinTheGame')" />

          <div class="btns">
            <button @click="game_confirm(false)">
              <img src="../../assets/img/game/button_notJoin.svg" alt="" />
            </button>
            <button @click="game_confirm(true)">
              <img src="../../assets/img/game/button_join.svg" alt="" />
            </button>
          </div>
        </div>

        <div v-if="gameMode" class="gameButtons">
          <div
            v-if="!game.gameOverVisible && !game.finished && game.status > 0"
            class="sellover"
          >
            <div class="iconBox">
              <img
                v-if="!game.mcSelected"
                src="../../assets/img/game/icon_beforeSelect.svg"
                alt=""
              />
              <img
                v-if="game.mcSelected"
                src="../../assets/img/game/icon_selected.svg"
                alt=""
              />
              <p>
                {{ $t('broadcast.selloverSelectState') }}<br />[{{
                  game.mcSelected
                    ? $t('broadcast.selected')
                    : $t('broadcast.worrying')
                }}]
              </p>
            </div>
          </div>

          <div
            v-if="
              !game.gameOverVisible &&
              !game.finished &&
              gameChallange &&
              game.status > 0
            "
            class="buttons"
          >
            <button @click="userSelect(1)" class="scissors">
              <img
                src="../../assets/img/game/button_game_scissors.svg"
                alt=""
              />
            </button>
            <button @click="userSelect(2)" class="rock">
              <img src="../../assets/img/game/button_game_rock.svg" alt="" />
            </button>
            <button @click="userSelect(3)" class="paper">
              <img src="../../assets/img/game/button_game_paper.svg" alt="" />
            </button>
          </div>

          <div
            class="centerBox"
            :class="{ gameovered: game.gameOverVisible || game.finished }"
          >
            <div
              v-if="!game.gameOverVisible && !game.finished && game.status > 0"
              class="gamming"
            >
              <p
                v-if="
                  (!game.mcSelected || (game.mcSelected && !game.countSync)) &&
                  game.isFinals === 1
                "
                class="roundBox"
              >
                {{ $t('broadcast.final') }}<br />1 vs {{ game.curJoinCnt }}
              </p>
              <p
                v-if="
                  (!game.mcSelected || (game.mcSelected && !game.countSync)) &&
                  game.isFinals !== 1
                "
                class="roundBox"
              >
                {{ $t('broadcast.round', { round: game.round }) }}<br />1 vs
                {{ game.curJoinCnt }}
              </p>

              <div
                v-if="game.mcSelected && !game.userSended && game.countSync"
                class="countBox"
              >
                <p
                  v-if="game.isFinals === 1"
                  class="count"
                  v-html="$t('broadcast.finalFin', { sec: gameCount })"
                />
                <p
                  v-else
                  class="count"
                  v-html="
                    $t('broadcast.finalFin', {
                      round: game.round,
                      sec: gameCount
                    })
                  "
                />

                <div v-if="gameChallange" class="selectedBox">
                  <img
                    v-if="game.userSelected === 1"
                    src="../../assets/img/game/button_game_scissors.svg"
                    alt=""
                  />
                  <img
                    v-if="game.userSelected === 2"
                    src="../../assets/img/game/button_game_rock.svg"
                    alt=""
                  />
                  <img
                    v-if="game.userSelected === 3"
                    src="../../assets/img/game/button_game_paper.svg"
                    alt=""
                  />
                </div>

                <p v-if="gameChallange && game.userSelected === 0" class="info">
                  {{ this.$t('broadcast.selectGamecard') }}
                </p>
                <p v-if="gameChallange && game.userSelected === 1" class="info">
                  {{ this.$t('broadcast.selectedSissors') }}
                </p>
                <p v-if="gameChallange && game.userSelected === 2" class="info">
                  {{ this.$t('broadcast.selectedRock') }}
                </p>
                <p v-if="gameChallange && game.userSelected === 3" class="info">
                  {{ this.$t('broadcast.selectedPaper') }}
                </p>
              </div>
            </div>

            <button v-if="game.finished" class="winBox" @click="exitGameMode">
              <img src="../../assets/img/game/img_celebrate.svg" alt="" />
              <!-- <span class="couponName">{{game.reward.name}}</span> -->
              <span
                class="nickName"
                v-html="
                  $t('broadcast.celebrateWinner', {
                    winner: game.winner.nickName
                  })
                "
              />
            </button>

            <button
              v-if="game.gameOverVisible"
              class="gameover"
              @click="gameOver"
            >
              <img src="../../assets/img/game/img_gameOver.svg" alt="" />
              <span>{{ $t('broadcast.exitGame') }}</span>
            </button>
          </div>
        </div>
        <!-- 가위바위보 게임 -->

        <!-- 라이브 쿠폰 -->
        <button
          v-if="liveCoupon.name !== ''"
          class="liveCoupon"
          @click="getCoupon"
        >
          <p class="txt_get">{{ $t('broadcast.receiveCoupon') }}</p>
          <div class="couponBox">
            <img src="../../assets/img/game/coupon.svg" alt="" />
            <p class="couponName">
              {{ liveCoupon.discountPolicyFigures | makeComma
              }}{{
                liveCoupon.discountPolicy === 1 ? $t('global.unitMoney') : '%'
              }}
            </p>
          </div>
          <p class="info" v-html="$t('broadcast.receivedLiveCoupon')" />
        </button>
        <!-- 라이브 쿠폰 -->

        <div
          class="pVodSoundDiv"
          v-if="clickSoundBtn"
          @click="soundBtn"
          :class="{ hide: !showHideFlag || chatFixFlag || chatFocus }"
        >
          <button class="pVodSound" v-if="vodSound"></button>
          <button class="pVodSound off" v-if="!vodSound"></button>
        </div>

        <button class="pVodSizingBtn" @click="vodToggleSize"></button>

        <div class="bottomDiv"></div>

        <!-- 좋아요, 공유 버튼 -->
        <div
          class="toolBox"
          :class="{ hide: !showHideFlag || chatFixFlag || chatFocus }"
        >
          <button class="btn_like" @click="likeAct"></button>
          <div class="heartBox" ref="heartBox"></div>
          <button class="btn_share" @click="shareAct"></button>
        </div>

        <!-- 구매여기 -->
        <div
          class="buyHere"
          ref="buyHere"
          :class="{ hide: !showHideFlag || chatFixFlag || chatFocus }"
        ></div>

        <!-- 상품롤링박스 -->
        <div
          v-if="vodInfo.broadcastPrdts.length"
          class="pVodProduct"
          @click="showPrdt()"
          :class="{ hide: !showHideFlag || chatFixFlag || chatFocus }"
        >
          <div class="pVodPrdtCnt">{{ vodInfo.prdtTotalCnt }}</div>
          <div class="prdtViewBox">
            <div
              class="prdtBox"
              :style="{
                width: (vodInfo.prdtTotalCnt + 1) * 66 + 'px',
                transform: `translateX(-${viewPrdtNo * 66}px)`
              }"
              ref="prdtSwiper"
            >
              <div
                class="productBox"
                v-for="(product, idx) in vodInfo.broadcastPrdts"
                :key="`broadcastPrdt_${idx}`"
              >
                <div
                  class="imgBox"
                  :style="{
                    backgroundImage: `url( ${
                      product.squareImageUrl || product.bigImageUrl
                    })`
                  }"
                ></div>

                <p class="pVodPrdtPrice">
                  {{ ProductService.prdtPrice(product).value | makeComma }}
                </p>
              </div>

              <!-- 복사 -->
              <div class="productBox">
                <div
                  class="imgBox"
                  :style="{
                    backgroundImage: `url( ${
                      vodInfo.broadcastPrdts[0].squareImageUrl ||
                      vodInfo.broadcastPrdts[0].bigImageUrl
                    })`
                  }"
                ></div>

                <p class="pVodPrdtPrice">
                  {{
                    ProductService.prdtPrice(vodInfo.broadcastPrdts[0]).value
                      | makeComma
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <button
          class="muteBtn"
          :class="{ hide: !showHideFlag || chatFixFlag || chatFocus }"
          @click.prevent="soundBtn"
        >
          {{ $t('broadcast.pressMuted') }}
        </button>
      </div>

      <VideoPlayer
        class="liveVideoWrap"
        ref="playerWrapper"
        :playMedia="playMedia"
        :poster="poster"
        :options="options"
        :showHideFlag="showHideFlag"
        :mode="'live'"
        :timeUpdateFlag="true"
        :autoplay="true"
        @player="setPlayer"
        @playerClose="playerClose"
        @videoClick="iconShowHide"
        v-if="playMedia.src"
      />
    </div>

    <!-- 채팅창 -->
    <div class="chatBox" :class="{ chatting: chatFixFlag || chatFocus }">
      <!-- 상품고정 -->
      <div
        class="prdtPined"
        :class="{ on: fixPrdtVisible, hide: !showHideFlag }"
      >
        <router-link
          v-if="fixPrdtSysId !== null"
          :to="`/product/${selectedPrdt.prdtSysId}/live/${selectedPrdt.broadcastProductSysId}`"
          @click.native="clickPrdt"
        >
          <div
            class="imgBox"
            :style="{
              backgroundImage: `url(${
                selectedPrdt.squareImageUrl || selectedPrdt.bigImageUrl
              })`
            }"
          ></div>
          <div class="txtBox">
            <h4>{{ selectedPrdt.name }}</h4>
            <p class="orgPrice">{{ selectedPrdt.marketPrice | makeComma }}</p>
            <p class="price">
              <span class="discount" v-if="selectedPrdt.discountRate > 0"
                >{{ selectedPrdt.discountRate }}<span>%</span></span
              >
              <span class="price"
                >{{ selectedPrdt.price | makeComma
                }}<span>{{ $t('global.unitMoney') }}</span></span
              >
            </p>
          </div>
        </router-link>

        <button
          class="prdtClose"
          v-if="fixPrdtSysId !== null"
          @click="closePrdt"
        >
          <img
            src="../../assets/img/ico/icon_live_close.png"
            :alt="$t('global.close')"
          />
        </button>
      </div>

      <!-- 홍보문구 -->
      <div
        class="marketingChat"
        :class="{ on: roomMarketing, hide: !showHideFlag }"
      >
        <div class="mChatBox" v-if="roomMarketing !== ''">
          <div class="txtChkBox" ref="txtChkBox">
            <p ref="flowText">{{ roomMarketing }}</p>
          </div>
        </div>

        <button
          class="matketClose"
          :class="{ hide: !showHideFlag }"
          v-if="roomMarketing !== ''"
          @click="closeMarket"
        >
          <img
            src="../../assets/img/ico/icon_live_close.png"
            :alt="$t('global.close')"
          />
        </button>
      </div>

      <!-- 공지사항 -->
      <div
        class="noticeChat"
        :class="{ hide: !showHideFlag || roomInfo.noti.length === 0 }"
      >
        <transition name="fade">
          <p :class="{ on: notiVisible }" @click="moreNoti()">
            <span
              ><img src="../../assets/img/ico/icon_live_notice.png" alt=""
            /></span>
            {{
              roomInfo.noti.length > 40
                ? roomInfo.noti.substring(0, 38) + '...'
                : roomInfo.noti
            }}

            <button class="notiMore" v-if="roomInfo.noti.length > 40">
              {{ $t('global.more') }}
            </button>
          </p>
        </transition>
      </div>

      <!-- 일반 채팅창 -->
      <ul
        class="chatHistory"
        ref="chatBox"
        :class="{ active: chatFocus || chatFixFlag, hide: !showHideFlag }"
      >
        <li
          v-for="(chat, idx) in chatList"
          :key="'chat_' + idx"
          :class="{
            ad: !chat.permission && chat.msgType === 0,
            me: myNick === chat.nick
          }"
        >
          <div class="norChat" v-if="chat.msgType === 0">
            <span
              class="chatNick"
              v-if="chat.permission && chat.msgType === 0"
              >{{ printNick(chat) }}</span
            ><span v-if="!chat.permission && chat.msgType === 0"
              ><img src="../../assets/img/ico/icon_live_adChat.png" alt=""
            /></span>
            {{ chat.msg }}
          </div>
          <div class="qa" v-if="chat.msgType === 1" @click="showAnswer(chat)">
            <p class="title">
              <span class="nick">{{ chat.nick }}</span>
              {{ $t('broadcast.arrivalAnswer') }}
            </p>
            <p class="param">
              <span class="cont">{{ chat.content }}</span>
              <button class="ans">{{ $t('broadcast.viewAnswer') }}</button>
            </p>
          </div>
        </li>
        <li class="chatDownBtn" :class="{ on: isScrolled }">
          <button @click="chatDown"></button>
        </li>
      </ul>
      <button
        class="hiddenBtn"
        :class="{ show: !showHideFlag, hide: showHideFlag }"
        @click="iconShowHide"
      ></button>
      <form
        @submit.prevent="chatSubmit"
        :class="{ full: chatFocus || chatFixFlag, hide: !showHideFlag }"
      >
        <input
          type="text"
          v-model="chatText"
          name="chatText"
          :placeholder="$t('broadcast.enjoyChat')"
          @focus="fixSizing($event)"
          @blur="nativeSizing"
          ref="chatInput"
          autocomplete="off"
        />
        <button
          class="submit"
          :class="{ disabled: chatDisable }"
          @click.prevent="chatSubmit"
          :disabled="chatDisable"
          ref="chatBtn"
        >
          {{ $t('broadcast.send') }}
        </button>
      </form>
    </div>

    <!-- 답변 & 공지사항 컴포넌트 -->
    <section class="answerPop" :class="{ active: activePop }">
      <div class="question" v-if="Object.keys(selectedAnswer).length > 0">
        <h1>{{ $t('broadcast.viewAnswer') }}</h1>
        <button class="close" @click="closeAnswer()"></button>
        <div class="info">
          <p
            v-html="$t('broadcast.chatAnswer', { nick: selectedAnswer.nick })"
          />
          <p class="q">{{ selectedAnswer.content }}</p>
          <p class="a">{{ selectedAnswer.answer }}</p>
        </div>
      </div>
      <div class="notiPop" v-if="isNoti">
        <h1>{{ $t('mypage.notice') }}</h1>
        <button class="close" @click="closeAnswer()"></button>
        <div class="info">
          <p>{{ roomInfo.noti }}</p>
        </div>
      </div>
    </section>

    <!-- 공유 컴포넌트 -->
    <shareSns
      class="shareBox"
      :class="{ on: isShare }"
      :eventTitle="vodInfo.shareTitle || vodInfo.title"
      :eventDescription="vodInfo.shareText || vodInfo.briefComment"
      :eventImage="vodInfo.shareThumnailUrl || vodInfo.thumnailLiveUrl"
      :eventLink="shareUrl"
      @close="snsClose"
      @copy="copy"
    ></shareSns>
    <div class="backPannel" @click="iconShowHide"></div>
  </div>
</template>

<script>
import shareSns from '@/components/shared/shareSns'
import { AppBridge } from '@/assets/js/common.js'
import ChatMinxin from './mixin/chatMixin.js'
import lottie from 'lottie-web'
import VideoPlayer from '@/components/shared/videoComponent'

export default {
  props: [
    'vodInfo',
    'prdtToggle',
    'pipMode',
    'viewCnt',
    'broadcastVodInfo',
    'showPrdtModal',
    'ProductService'
  ],
  components: {
    shareSns,
    VideoPlayer
  },
  mixins: [ChatMinxin],
  data() {
    return {
      player: null,
      windowHeight: window.innerHeight,
      videoUiHeight: '100%',
      showPrdtFlag: false,
      showQnaFlag: false,
      vodSound: false,
      turnOn: true,
      clickSoundBtn: true,
      window: window,
      poster: null,
      showHideFlag: true,
      iosStart: 0,
      iosEnd: 0,
      chatText: '',
      chatFocus: false,
      chatFixFlag: false,
      nSizingClear: null,
      myNick: sessionStorage.getItem('nickName') || null,
      buyHere: null,
      activePop: false,
      selectedAnswer: {},
      isNoti: false,
      roomInfo: {
        viewCnt: 0,
        likeCnt: 0,
        noti: ''
      },
      notiVisible: false,
      fixPrdtSysId: null,
      fixPrdtVisible: false,
      selectedPrdt: null,
      roomMarketing: '',
      clearVar: null,
      viewPrdtNo: 0,
      viewPrdtTo: null,
      rollingFixPrdt: null,
      isShare: false,
      hearts: [
        '/static/images/heart1.png',
        '/static/images/heart2.png',
        '/static/images/heart3.png',
        '/static/images/heart4.png',
        '/static/images/heart5.png',
        '/static/images/heart6.png'
      ],
      oldChatSize: 0,
      newChatSize: 0,
      closingPop: false,
      isScrolled: false,
      chatDisable: true,
      chatServiceOption: {
        room: {
          room: this.broadcastVodInfo.bcScheduleSysId
        },
        user: {
          nickName: ''
        },
        mode: 'live',
        playerBox: '.pVodWrap.live'
      },
      isVideoInit: false,
      endStatus: false,
      errChk: null,

      options: {
        type: Object,
        default() {
          return {
            autoplay: 'muted',
            controls: true,
            height: 'auto',
            loop: false,
            preload: 'auto',
            width: '100%',
            controlBar: {
              fullscreenToggle: false
            },
            userActions: {
              doubleClick: false
            }
          }
        }
      },
      playMedia: {
        src: null,
        type: ''
      }
    }
  },

  methods: {
    printNick(chat) {
      let nick = chat.nick
      if (nick === '') nick = chat.userId.substring(0, 3) + '**'

      return nick
    },

    snsClose() {
      this.isShare = false
    },
    copy() {
      alert(this.$t('global.copiedUrl'))
    },

    setPlayer(player) {
      this.player = player

      this.player.on('play', (e) => {
        this.isVideoInit = true

        this.vodSound = !this.player.muted()

        this.player.muted(false)
        this.vodSound = true
      })

      const DEF_ERR = {
        0: () => {
          alert(this.$t('global.errored'))
        },
        1: () => {
          alert(this.$t('global.errored'))
        },
        2: () => {
          alert(this.$t('global.networkError'))
          this.playerClose()
        },
        3: () => {
          alert(this.$t('global.errored'))
        },
        4: () => {
          // 라이브체크
          this.chkLiveStatus()
        }
      }

      this.player.on('error', async (e) => {
        const errCode = this.player.error().code

        DEF_ERR[errCode]()
      })
    },

    // 플레이어 종료
    playerClose() {
      return window.closePip()
    },

    // 라이브 체크
    async chkLiveStatus() {
      let status = await this.chatService._ChkLiveStatus(
        this.broadcastVodInfo.bcSysId
      )
      console.log('player live chk', status)
      if (status) {
        alert(this.$t('broadcast.liveEnd'))
        return window.closePip()
      }
    },

    // 플레이어 미디어 설정
    setSrc() {
      this.playMedia = {
        src: this.vodInfo.liveUrl,
        type: 'application/x-mpegURL'
      }
      this.options.poster = this.vodInfo.thumnailLiveUrl
    },

    streamStart() {
      if (this.player) return this.player.play()
    },

    vodClosed() {
      let vodInfo = {
        broadcastSysId: null,
        broadcastScheduleSysId: null,
        vodPlaying: false,
        pipMode: false,
        top: 0,
        right: 0
      }
      window.pastVod(vodInfo)
      AppBridge.send('VodPipExit', { value: 'close' }, true)
      // this.$router.go(-1)
    },
    vodToggleSize() {
      if (window.pastVodPip) {
        let param = {
          pipMode: !this.pipMode,
          top: 0,
          right: 0
        }
        window.pastVod(param)
        AppBridge.send('VodScreenStatus', { value: param.pipMode }, true)
      }
    },
    showPrdt() {
      this.showPrdtFlag = true
      this.$emit('prdtListFlag', this.showPrdtFlag)
    },
    showQna() {
      this.showQnaFlag = true
      this.$emit('prdtQnaFlag', this.showQnaFlag)
    },
    iconShowHide() {
      if (this.chatFixFlag || this.chatFocus) return false
      if (this.activePop) return (this.activePop = false)
      if (this.showPrdtModal) return this.$emit('closeModal', false)
      this.showHideFlag = !this.showHideFlag
    },
    soundBtn() {
      this.vodSound = !this.vodSound
      if (this.vodSound === false) {
        this.player.muted(true)
      } else {
        this.player.muted(false)
      }
    },
    clickFlag() {
      // vod를 pip모드로 변환
      let param = {
        pipMode: true
      }
      window.pastVod(param)
      AppBridge.send('VodScreenStatus', { value: param.pipMode }, true)
    },
    iosChangePip() {
      window.addEventListener('touchstart', this.onStart, { capture: true })
      window.addEventListener('touchend', this.onEnd, { capture: true })
    },
    onStart(e) {
      let vodBox = document.querySelector('.liveVideoWrap')
      if (e.target === vodBox) {
        this.iosStart = e.changedTouches[0].pageY
      }
    },
    onEnd(e) {
      let vodBox = document.querySelector('.liveVideoWrap')
      if (e.target === vodBox) {
        this.iosEnd = e.changedTouches[0].pageY
        let move = this.iosStart - this.iosEnd

        if (this.iosEnd < this.iosStart && move > 60) {
          this.clickFlag()
        }
      }
    },

    async chatSubmit() {
      if (await window.isDemo()) {
        return false
      }
      
      if (this.chatDisable) return false
      this.$refs.chatInput.focus()
      clearTimeout(this.nSizingClear)

      let msgObj = {
        msg: this.chatText
      }
      this.sendChat(msgObj)

      this.chatText = ''
      this.$refs.chatInput.value = ''
    },

    fixSizing(e) {
      if (sessionStorage.getItem('accessToken')) {
        this.chatFocus = true

        this.$refs.playerWrapper.height = `${this.windowHeight}px`
      } else {
        e.preventDefault()
        e.target.blur()
        let cf = confirm(this.$t('broadcast.chatNeedLogin'))
        if (cf) {
          let vodInfo = {
            broadcastSysId: null,
            broadcastScheduleSysId: null,
            vodPlaying: false,
            pipMode: false,
            type: null,
            top: 0,
            right: 0
          }

          window.pastVod(vodInfo)
          AppBridge.send('VodPipExit', { value: 'close' }, true)

          this.goLogin()
        }
        return
      }
    },
    nativeSizing() {
      clearTimeout(this.nSizingClear)

      this.nSizingClear = setTimeout(() => {
        this.chatFocus = false
        this.chatFixFlag = false
        this.$refs.playerWrapper.height = '100%'
        this.$refs.chatInput.blur()
        this.$refs.chatBtn.blur()
      }, 300)
    },

    // 구매여기 아이콘
    buyHereAni() {
      this.buyHere.stop()
      this.buyHere.play()
    },

    // 답변보기 클릭시
    showAnswer(data) {
      if (this.closingPop) return false
      this.selectedAnswer = data
      this.activePop = true
      this.isNoti = false
    },

    // 답변보기 닫기
    closeAnswer() {
      this.activePop = false
      this.closingPop = true
      setTimeout(() => {
        this.selectedAnswer = {}
        this.isNoti = false
        this.closingPop = false
      }, 1000)
    },

    // 공지 더보기
    moreNoti() {
      if (this.closingPop) return false
      this.selectedAnswer = {}
      this.isNoti = true
      this.activePop = true
    },

    // 공지사항 닫기
    closeNoti() {
      this.notiVisible = false
      setTimeout(() => {
        this.roomInfo.noti = ''
      }, 1000)
    },

    // 홍보문구 플로우 함수
    flowText(textEl) {
      if (this.clearVar) {
        clearTimeout(this.clearVar)
        this.clearVar = null
      }

      let width = textEl.clientWidth
      let parentWidth = textEl.parentNode.clientWidth
      textEl.style.transform = `translateX(0)`
      textEl.style.transition = `none`
      let timming = 0
      if (width > parentWidth) {
        timming = (width * 40) / 1000

        setTimeout(function () {
          textEl.style.transition = `transform ${timming}s linear`
          textEl.style.transform = `translateX(calc(-100% + ${parentWidth}px))`
        }, 800)
      }
      this.clearVar = setTimeout(
        function () {
          this.roomMarketing = ''
          textEl.style.width = '0px'
        }.bind(this),
        timming * 1000 + 5000
      )
    },

    // 홍보문구 닫기
    closeMarket() {
      this.roomMarketing = ''
    },

    // 상품고정 닫기
    closePrdt() {
      this.fixPrdtVisible = false
      setTimeout(() => {
        this.fixPrdtSysId = null
      }, 1000)
    },

    // 상품 클릭
    clickPrdt() {
      // vod를 pip모드로 변환
      let param = {
        pipMode: true
      }
      window.pastVod(param)
      AppBridge.send('VodScreenStatus', { value: param.pipMode }, true)

      this.fixPrdtSysId = null
    },

    // 상품 롤링
    rollingPrdt() {
      let swiper = this.$refs.prdtSwiper
      let max = this.vodInfo.broadcastPrdts.length
      clearTimeout(this.viewPrdtTo)
      this.viewPrdtTo = setTimeout(() => {
        this.viewPrdtNo++

        if (this.viewPrdtNo >= max) {
          setTimeout(() => {
            if (swiper) {
              swiper.style.transition = 'none'
              this.viewPrdtNo = 0
              setTimeout(() => {
                swiper.style.transition = 'transform 0.5s ease'
              }, 0)
            }
          }, 500)
        }

        this.rollingPrdt()
      }, 4000)
    },

    // 상품롤링 고정함수
    rollingFix() {
      let prdt = this.vodInfo.broadcastPrdts.filter(
        (x) => x.prdtSysId === this.rollingFixPrdt
      )[0]
      let idx = this.vodInfo.broadcastPrdts.indexOf(prdt)
      this.viewPrdtNo = idx
      clearTimeout(this.viewPrdtTo)
    },

    // 공유버튼 동작
    shareAct() {
      this.isShare = true
    },

    // 스트리밍 컨트롤 (영상)
    streaming(flag) {
      if (flag === 0) return this.player.pause()
      if (flag === 1) return this.streamStart()
      if (flag === 2) return this.liveExit()
    },

    // 방송종료
    liveExit() {
      this.isVideoInit = false

      setTimeout(() => {
        this.player.pause()
        alert(this.$t('broadcast.liveEnd'))
        window.closePip()
      }, 10000)
    },

    // 채팅창 스크롤 가장 하단으로
    chatScroll() {
      let box = this.$refs.chatBox
      let st = box.scrollTop
      let dif = 0
      if (this.oldChatSize === 0) {
        this.oldChatSize = this.newChatSize
      } else if (
        this.oldChatSize !== this.newChatSize &&
        this.oldChatSize >= this.newChatSize
      ) {
        dif = this.oldChatSize - this.newChatSize
        st = st + dif
      }

      if (box.scrollHeight - (st + box.clientHeight) <= 150) {
        box.scrollTop = box.scrollHeight
      }
      this.oldChatSize = this.newChatSize
    },

    chkScroll() {
      let box = this.$refs.chatBox
      let dif = box.scrollHeight - (box.scrollTop + box.clientHeight)
      if (dif >= 150) {
        this.isScrolled = true
      } else {
        this.isScrolled = false
      }
    },

    // 채팅창 최하단 이동
    chatDown() {
      this.$refs.chatBox.scrollTop = this.$refs.chatBox.scrollHeight
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.setSrc()

      // 안드로이드 웹 용 전송버튼 활성화
      let UA = navigator.userAgent.toLowerCase()
      if (UA.indexOf('android') > -1 && UA.indexOf('native') < 0) {
        this.chatDisable = false
      }

      this.hearts.forEach((h) => {
        let img = document.createElement('img')
        img.setAttribute('src', h)
      })
    })

    // 구매여기 아이콘 호출
    this.buyHere = lottie.loadAnimation({
      container: this.$refs.buyHere,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: '/static/images/purchaseanim.json'
    })

    // 채팅창 스크롤 이벤트 리스너
    this.$refs.chatBox.addEventListener('scroll', (e) => this.chkScroll())
  },

  watch: {
    vodInfo: {
      handler(od, nd) {
        if (od.broadcastSysId !== nd.broadcastSysId) {
          this.viewPrdtNo = 0
          this.showHideFlag = true
          this.chatList = []

          this.playMedia = {
            src: this.vodInfo.liveUrl,
            type: 'application/x-mpegURL'
          }
          this.poster = this.vodInfo.thumnailLiveUrl
        }
      }
    },

    chatText: {
      handler() {
        if (this.chatText !== '') {
          this.chatFixFlag = true
        } else {
          this.chatFixFlag = false
        }

        if (this.chatText.trim().length === 0) {
          this.chatDisable = true
          let UA = navigator.userAgent.toLowerCase()
          if (UA.indexOf('android') > -1 && UA.indexOf('native') < 0) {
            this.chatDisable = false
          }
        } else if (this.chatText.length >= 140) {
          this.chatDisable = false
          this.chatText = this.chatText.substr(0, 139)
        } else {
          this.chatDisable = false
        }
      }
    },

    chatFocus: {
      handler() {
        if (!this.chatFixFlag && !this.chatFocus)
          this.$refs.playerWrapper.height = '100%'
      }
    },
    chatFixFlag: {
      handler() {
        if (!this.chatFixFlag && !this.chatFocus)
          this.$refs.playerWrapper.height = '100%'
      }
    },
    roomMarketing: {
      handler(ot, nt) {
        if (this.roomMarketing !== '' && ot !== nt) {
          setTimeout(() => {
            this.$refs.flowText.style.width = 'auto'
            this.$refs.txtChkBox.style.width = '100000px'
            let width = this.$refs.flowText.clientWidth + 1 + 'px'
            this.$refs.flowText.style.width = width
            this.$refs.txtChkBox.style.width = width
            this.flowText(this.$refs.txtChkBox)
          }, 0)
        }
      }
    },

    fixPrdtSysId: {
      handler() {
        if (this.fixPrdtSysId) {
          this.selectedPrdt = this.vodInfo.broadcastPrdts.filter(
            (x) => x.prdtSysId === this.fixPrdtSysId
          )[0]
        }
      }
    }
  },

  updated() {
    this.$nextTick(() => {
      let box = this.$refs.chatBox
      this.newChatSize = box.clientHeight

      this.chatScroll()
    })
  },

  beforeDestroy() {
    window.closePip()
    if (this.chatService) {
      this.chatService._clearChatService()
      this.chatService = null
    }

    this.$refs.chatBox.removeEventListener('scroll', this.chkScroll())
  },

  computed: {
    shareUrl() {
      let url = window.location.href.split('//')
      url = url[0] + '//' + url[1].substr(0, url[1].indexOf('/'))
      return `${url}/Vod/${this.broadcastVodInfo.bcSysId}/${this.broadcastVodInfo.bcScheduleSysId}/live`
    },

    brandRounting() {
      // 브랜드 이동 기능. app.vue window.routeGo2, vodPlay 두군데 같이 수정 필요
      // liveInfoContent 도 수정 필요

      return `/BrandChannel/${this.vodInfo.brandSysId}`
    }
  }
}
</script>
<style lang="scss">
.pVodWrap.fixed {
  overflow: hidden;
}
.livePlayer,
.pVodWrap.live,
.pVodWrap.live .pVodInner {
  width: 100%;
  height: 100%;
}

.liveVideoWrap {
  position: absolute;
  top: 0;
  left: 0;
}

.pVodWrap.live .pVodInner .hiddenPanel {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
}
.pVodWrap.live .pVodInner .hiddenPanel.higher {
  z-index: 10;
}
.pVodWrap .pVodInner .topDiv {
  width: 100%;
  height: 25%;
  position: absolute;
  object-fit: contain;
  z-index: 2;
  // overflow: scroll;
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.25),
    rgba(0, 0, 0, 0)
  );
}

.pVodWrap .pVodInner .bottomDiv {
  width: 100%;
  height: 60%;
  bottom: 0;
  position: absolute;
  object-fit: contain;
  z-index: 2;
  // overflow: scroll;
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
}

.pVodWrap .pVodInner .pVodTop img {
  position: absolute;
  object-fit: contain;
  z-index: 5;
  overflow: hidden;
}

.pVodWrap .pVodInner .pVodTop .logo {
  position: absolute;
  width: 62px;
  height: 26px;
  top: 20px;
  left: 9px;
  object-fit: contain;
  z-index: 5;
  overflow: hidden;
}
.native.aosApp:not(.notch) .pVodWrap .pVodInner .pVodTop .logo {
  top: 50px;
}

.pVodWrap .pVodInner .pVodTop .live {
  position: absolute;
  width: 54px;
  height: 26px;
  top: 20px;
  left: 80px;
  object-fit: contain;
  z-index: 5;
  overflow: hidden;
}
.native.aosApp:not(.notch) .pVodWrap .pVodInner .pVodTop .live {
  top: 50px;
}

.pVodWrap .pVodInner .brandImg {
  position: absolute;
  z-index: 12;
  top: 55px;
  left: 7px;
  overflow: hidden;
  width: 100%;
  margin-left: 1px;
}
.native.aosApp:not(.notch) .pVodWrap .pVodInner .brandImg {
  top: 85px;
}
.pVodWrap .pVodInner .brandImg a {
  display: block;
  float: left;
  z-index: 10;
}

.pVodWrap .pVodInner .brandImg .brdImgDiv {
  z-index: 5;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: solid 1px #dbdbdb;
  box-sizing: border-box;
  overflow: hidden;
  margin: 5px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  background-color: #fff;
}
.pVodWrap .pVodInner .brandImg .brdImg {
  z-index: 5;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: block;
}

.pVodWrap .pVodInner .brandImg .rerDiv {
  position: absolute;
  top: 34px;
  left: 1px;
  width: 50px;
  height: 18px;
  padding: 3px;
}

.pVodWrap .pVodInner .brandImg .rerDiv .rerun {
  object-fit: cover;
  position: relative;
  /* top: 34px; */
  width: 50px;
  height: 18px;
  z-index: 5;
  border-radius: 50px;
  box-sizing: border-box;
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.05);
  background-image: linear-gradient(to right, var(--warm-grey) 2%, #767676 99%);
}
.pVodWrap .pVodInner .brandTxt {
  z-index: 5;
  font-size: 15px;
  width: calc(100% - 62px);
  /* margin-top: 7px; */
  margin-left: 4px;
  color: #fff;
  float: left;
}
.pVodWrap .pVodInner .brandTxt p {
  z-index: 5;
  text-shadow: 0 1px 2px rgba(20, 20, 20, 0.4);
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.64px;
  text-align: left;
  color: #ffffff;
  padding-right: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: calc(100% - 10px);
  box-sizing: border-box;
  word-wrap: normal;
  margin-bottom: 6px;
}

.pVodWrap .pVodInner .brandTxt span {
  text-shadow: 0 1px 2px rgba(20, 20, 20, 0.4);
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.56px;
  text-align: left;
  color: #ffffff;
  z-index: 5;
}

.pVodWrap .pVodInner .brandTxt .watchCnt {
  display: inline-block;
  margin-left: 8px;
}
.pVodWrap .pVodInner .brandTxt .likeCnt {
  display: inline-block;
  margin-left: 4px;
}

.pVodWrap .pVodInner .brandTxt .watchCnt img,
.pVodWrap .pVodInner .brandTxt .likeCnt img {
  width: 20px;
  height: 20px;
  padding: 3px 3px;
  object-fit: contain;
  vertical-align: middle;
  z-index: 5;
}

.pVodWrap .pVodInner .brandTxt .watchCnt span,
.pVodWrap .pVodInner .brandTxt .likeCnt span {
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.48px;
  text-align: left;
  color: #ffffff;
  z-index: 5;
}

.livePlayer .pVodWrap .pVodInner .pVodSoundDiv .pVodSound {
  position: absolute;
  z-index: 10;
  width: 30px;
  height: 30px;
  object-fit: contain;
  top: 14px;
  right: 55px;
  background: url('../../assets/img/ico/icon_sound_on_wh.png') 0 0 / 100% auto
    no-repeat;
  outline: none;
}
.native.aosApp:not(.notch) .pVodWrap .pVodInner .pVodSoundDiv .pVodSound {
  top: 44px;
}

.pVodWrap .pVodInner .pVodSoundDiv .pVodSound.off {
  z-index: 10;
  background: url('../../assets/img/ico/icon_sound_off_wh.png') 0 0 / 100% auto
    no-repeat;
}

.pVodWrap .pVodInner .pVodSizingBtn {
  position: absolute;
  top: 14px;
  right: 9px;
  z-index: 10;
  display: block;
  width: 30px;
  height: 30px;
  background: url('../../assets/img/ico/icon_exit_full-screen_wh.png') 0 0 /
    30px 30px no-repeat;
  opacity: 1;
  transition: all 0.3s ease-in-out;
  outline: none;
}
.pVodWrap .pVodInner .pVodSizingBtn.hide {
  display: none;
}
.pipMod .pVodWrap .pVodInner .pVodSizingBtn {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 14;
}
.native.aosApp:not(.notch) .pVodWrap .pVodInner .pVodSizingBtn {
  top: 44px;
}

.pVodWrap .pVodInner .pVodIconShow.show {
  position: absolute;
  top: 14px;
  right: 55px;
  z-index: 10;
  display: block;
  width: 30px;
  height: 30px;
  background: url('../../assets/img/ico/icon_hide_wh.png') 0 0 / 30px 30px
    no-repeat;
  opacity: 1;
  transition: all 0.3s ease-in-out;
  outline: none;
}

.pVodWrap .pVodInner .pVodIconShow.hide {
  position: absolute;
  top: 14px;
  right: 55px;
  z-index: 10;
  display: block;
  width: 30px;
  height: 30px;
  opacity: 1;
  transition: all 0.3s ease-in-out;
  background: url('../../assets/img/ico/icon_show_wh.png') 0 0 / 30px 30px
    no-repeat;
  outline: none;
}

.pVodWrap .pVodInner .pVodClose .closeX {
  position: absolute;
  z-index: 10;
  overflow: hidden;
  top: 15px;
  right: 15px;
  width: 30px;
  height: 30px;
  background: url('../../assets/img/ico/icon_close_wh.png') 0 0 / 100% auto
    no-repeat;
}

.pVodWrap .pVodInner .pVodProduct {
  overflow: visible;
  position: absolute;
  bottom: 15px;
  right: 12px;
  z-index: 10;
  width: 66px;
}
.pVodWrap .pVodInner .pVodProduct .prdtViewBox {
  overflow: hidden;
  width: 66px;
  height: 66px;
  background: #fff;
  border-radius: 4px;
}
.pVodWrap .pVodInner .pVodProduct .prdtBox {
  height: 100%;
  transition: transform 0.5s ease;
  transform: translateX(0);
}
.pVodWrap .pVodInner .pVodProduct .productBox {
  position: relative;
  float: left;
  overflow: hidden;
  width: 66px;
  height: 66px;
  border: solid 1px #ededed;
  box-sizing: border-box;
}

.pVodWrap .pVodInner .pVodProduct .imgBox {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  cursor:pointer;
}

.pVodWrap .pVodInner .pVodProduct .pVodPrdtCnt {
  position: absolute;
  top: -7px;
  right: -4px;
  width: 20px;
  height: 16px;
  border-radius: 8px;
  background-image: linear-gradient(to right, $main-color2, $main-color);
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.48;
  letter-spacing: -0.48px;
  color: #ffffff;
  z-index: 10;
}
.pVodWrap .pVodInner .pVodProduct .pVodPrdtPrice {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 16px;
  border-bottom: none;
  text-align: center;
  background-color: white;
  font-size: 11px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 17px;
  letter-spacing: -0.44px;
  color: #191919;
  border-radius: 0 0 8px 8px;
}

.pVodWrap .prdtToggleBox {
  height: 100px;
  width: 100%;
  z-index: 10;
}

.pVodWrap.live .pVodInner .muteBtn {
  position: fixed;
  top: 120px;
  left: 12px;
  z-index: 11;
  display: none;
  padding: 8px 8px 8px 31px;
  border-radius: 8px;
  font-size: 14px;
  color: #fff;
  line-height: 1;
  letter-spacing: -0.48px;
  background-color: rgba(0, 0, 0, 0.8);
  background-image: url('../../assets/img/ico/icon_sound_off_wh_sm.png');
  background-position: 8px 50%;
  background-size: 20px 20px;
  background-repeat: no-repeat;
}

.pVodWrap.live .pVodInner .is-muted + .muteBtn {
  display: inline-block;
}
.pVodWrap.live .pVodInner .is-muted + .muteBtn.hide {
  display: none;
}

.pVodWrap .pVodInner .is-playing .fp-engine {
  background: #000;
}

.pVodWrap .pVodInner .flowplayer.is-muted .fp-volumebtn:after {
  display: none;
}

.pVodWrap .pVodInner .flowplayer .fp-switch.fp-play-1 .fp-pause {
  background: url('../../assets/img/ico/icon_fuzz_btn_wh@3x.png') 50% 50% / 100%
    auto no-repeat;
  z-index: 10;
}

.pVodWrap .pVodInner .flowplayer .fp-switch.fp-play-1 .fp-play {
  background: url('../../assets/img/ico/icon_play_btn_wh@3x.png') 50% 50% / 100%
    auto no-repeat;
  z-index: 10;
}

.pVodWrap .pVodInner .flowplayer .fp-switch.fp-play-1 {
  width: 85px;
  height: 85px;
}

.pVodWrap .pVodInner .is-seeking .fp-switch.fp-play-1,
.pVodWrap .pVodInner .is-waiting .fp-switch.fp-play-1 {
  display: none;
}

.pVodWrap .pVodInner .fp-timeline,
.pVodWrap .pVodWrap .pVodInner .fp-duration {
  z-index: 10;
}

.pVodWrap .buyHere {
  opacity: 1;
  position: absolute;
  bottom: 80px;
  right: 4px;
  z-index: 11;
  width: 80px;
  height: 80px;
  pointer-events: none;
  transition: all 0.3s ease;
}

.livePlayer .toolBox {
  position: absolute;
  bottom: 120px;
  right: 12px;
  z-index: 10;
  width: 40px;
}
.livePlayer .toolBox.hide {
  display: block;
  opacity: 0;
}
.livePlayer .toolBox.hide button {
  display: none;
}
.pipMod .livePlayer .toolBox,
.pipMod .pVodWrap .buyHere {
  transform: scale(0.01, 0.01);
}

.livePlayer .toolBox .heartBox {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 4;
  width: 32px;
  height: 32px;
}
.livePlayer .toolBox .heartBox img {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
}
.livePlayer .toolBox .heartBox img.ani0,
.livePlayer .toolBox .heartBox img.ani3 {
  animation: heartAni 2s alternate forwards linear;
}
.livePlayer .toolBox .heartBox img.ani1,
.livePlayer .toolBox .heartBox img.ani4 {
  animation: heartAni2 2s alternate forwards linear;
}
.livePlayer .toolBox .heartBox img.ani2,
.livePlayer .toolBox .heartBox img.ani5 {
  animation: heartAni3 2s alternate forwards linear;
}
@keyframes heartAni {
  0% {
    opacity: 1;
    transform: translate(0, 0);
  }
  10% {
    transform: translate(-6px, -25px);
  }
  20% {
    transform: translate(-8px, -50px);
  }
  30% {
    transform: translate(-5px, -75px);
  }
  50% {
    transform: translate(2px, -125px);
  }
  60% {
    transform: translate(4px, -150px);
  }
  70% {
    transform: translate(3px, -175px);
  }
  90% {
    transform: translate(1px, -225px);
  }
  100% {
    opacity: 0;
    transform: translate(0px, -250px);
  }
}
@keyframes heartAni2 {
  0% {
    opacity: 1;
    transform: translate(0, 0);
  }
  10% {
    transform: translate(6px, -28px);
  }
  20% {
    transform: translate(8px, -56px);
  }
  30% {
    transform: translate(5px, -84px);
  }
  50% {
    transform: translate(-2px, -140px);
  }
  60% {
    transform: translate(-4px, -168px);
  }
  70% {
    transform: translate(-3px, -196px);
  }
  90% {
    transform: translate(-1px, -252px);
  }
  100% {
    opacity: 0;
    transform: translate(0px, -280px);
  }
}
@keyframes heartAni3 {
  0% {
    opacity: 1;
    transform: translate(0, 0);
  }
  10% {
    transform: translate(4px, -20px);
  }
  20% {
    transform: translate(6px, -40px);
  }
  30% {
    transform: translate(5px, -60px);
  }
  50% {
    transform: translate(-1px, -100px);
  }
  60% {
    transform: translate(-3px, -120px);
  }
  70% {
    transform: translate(-2px, -140px);
  }
  90% {
    transform: translate(1px, -180px);
  }
  100% {
    opacity: 0;
    transform: translate(0px, -200px);
  }
}

.livePlayer .toolBox button {
  position: relative;
  z-index: 10;
  display: block;
  width: 40px;
  height: 40px;
  margin-top: 16px;
  outline: none;
}
.livePlayer .toolBox button:first-child {
  margin-top: 0;
}
.livePlayer .toolBox .btn_like {
  background: url('../../assets/img/ico/icon_live_bigHeart.png') 50% 50% / 24px
    24px no-repeat;
}
.livePlayer .toolBox .btn_share {
  background: url('../../assets/img/ico/icon_live_share.png') 50% 50% / 24px
    24px no-repeat;
}

.livePlayer .answerPop {
  overflow: hidden;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 20;
  width: 100%;
  height: 0;
  border-radius: 12px 12px 0 0;
  background: #fff;
  transition: all 0.5s ease-in-out;
  transform: translateY(100%);
}
.livePlayer .answerPop.active {
  transform: translateY(0);
  height: 50%;
}
.livePlayer .answerPop h1 {
  width: calc(100% - 20px);
  margin-left: 10px;
  padding: 17px 0 13px;
  font-size: 16px;
  font-weight: 500;
  border-bottom: 1px solid #ddd;
  line-height: 1;
}
.livePlayer .answerPop .close {
  position: absolute;
  top: 12px;
  right: 10px;
  display: block;
  width: 24px;
  height: 24px;
  background: url('../../assets/img/ico/icon_close_bk.png') 50% 50% / 24px auto
    no-repeat;
}
.livePlayer .answerPop .info {
  padding: 10px;
  color: #767676;
}
.livePlayer .answerPop .notiPop .info {
  color: #111;
}
.livePlayer .answerPop .info p {
  margin-bottom: 20px;
}
.livePlayer .answerPop .info p:first-child {
  font-weight: 700;
}
.livePlayer .answerPop .notiPop .info p:first-child {
  font-weight: 400;
}
.livePlayer .answerPop .info p:first-child > span {
  font-weight: 400;
}
.livePlayer .answerPop .info .q {
  margin: 10px 0;
  font-size: 15px;
  color: #111;
  line-height: 1.29;
  word-break: break-all;
}
.livePlayer .answerPop .info .q:before {
  content: 'Q';
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 5px;
  border-radius: 50%;
  background: #ececec;
  font-size: 12px;
  text-align: center;
  line-height: 24px;
  color: #5c5c5c;
  vertical-align: middle;
}
.livePlayer .answerPop .info .a {
  margin: 10px 0;
  font-size: 15px;
  color: #111;
  line-height: 1.29;
  word-break: break-all;
}
.livePlayer .answerPop .info .a:before {
  content: 'A';
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 5px;
  border-radius: 50%;
  background: #ececec;
  font-size: 12px;
  text-align: center;
  line-height: 24px;
  color: $main-color;
  vertical-align: middle;
}

.livePlayer .chatBox {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 7;
  display: block;
  width: calc(100% - 120px);
  margin-left: 10px;
  height: calc(100% - 250px);
  box-sizing: border-box;
}
.pipMod .livePlayer .chatBox {
  position: absolute;
}
.livePlayer .chatBox .prdtPined {
  position: relative;
  width: 100%;
  height: 70px;
  transition: all 1s ease;
  opacity: 0;
}
.livePlayer .chatBox .prdtPined.on {
  opacity: 1;
}
.livePlayer .chatBox .prdtPined a {
  overflow: hidden;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.2);
}
.livePlayer .chatBox .prdtPined .imgBox {
  float: left;
  width: 70px;
  height: 70px;
  background-size: contain;
  background-position: 50% 50%;
  background-repeat: no-repeat;
}
.livePlayer .chatBox .prdtPined .txtBox {
  float: left;
  width: calc(100% - 78px);
  height: 100%;
  margin-left: 8px;
  padding: 5px 0;
  color: #fff;
  line-height: 1.29;
  letter-spacing: -0.56px;
  box-sizing: border-box;
}
.livePlayer .chatBox .prdtPined .txtBox h4 {
  overflow: hidden;
  width: calc(100% - 38px);
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  font-weight: 400;
}
.livePlayer .chatBox .prdtPined .txtBox .orgPrice {
  margin: 2px 0;
  color: #dbdbdb;
  text-decoration: line-through;
}
.livePlayer .chatBox .prdtPined .txtBox .price {
  overflow: hidden;
  font-size: 18px;
  font-weight: 700;
}
.livePlayer .chatBox .prdtPined .txtBox .discount {
  color: #ffe24d;
}
.livePlayer .chatBox .prdtPined .txtBox .discount span,
.livePlayer .chatBox .prdtPined .txtBox .price .price span {
  margin-left: 1px;
  font-size: 14px;
  font-weight: 400;
  vertical-align: middle;
}
.livePlayer .chatBox .prdtPined .txtBox .price .price {
  margin-left: 4px;
}

.livePlayer .chatBox .marketingChat {
  position: relative;
  width: 100%;
  height: 37px;
  margin-top: 10px;
  padding: 0 24px 0 10px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.2);
  transition: all 1s ease;
  opacity: 0;
  box-sizing: border-box;
}
.livePlayer .chatBox .marketingChat.on {
  opacity: 1;
}
.livePlayer .chatBox .marketingChat.hide {
  display: block;
  opacity: 0;
}
.livePlayer .chatBox .marketingChat.hide .matketClose.hide {
  display: none;
}
.livePlayer .chatBox .marketingChat .mChatBox {
  overflow: hidden;
}
.livePlayer .chatBox .marketingChat p {
  display: inline-block;
  color: #ffca85;
  line-height: 37px;
}
.livePlayer .chatBox .marketingChat .matketClose,
.livePlayer .chatBox .prdtPined .prdtClose {
  position: absolute;
  top: 8px;
  right: 3px;
  display: block;
  width: 20px;
  height: 20px;
  background: transparent;
}
.livePlayer .chatBox .marketingChat .matketClose img,
.livePlayer .chatBox .prdtPined .prdtClose img {
  display: block;
  width: 100%;
}

.livePlayer .chatBox .noticeChat {
  width: 100%;
  height: 48px;
  margin-top: 10px;
  color: #ffe24d;
}
.livePlayer .chatBox .noticeChat p {
  position: relative;
  padding: 4px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.2);
  letter-spacing: -0.56px;
  transition: all 1s ease;
  opacity: 0;
  text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
  word-break: break-all;
}
.livePlayer .chatBox .noticeChat p.on {
  opacity: 1;
}
.livePlayer .chatBox .noticeChat span {
  display: inline-block;
  height: 20px;
  vertical-align: top;
}
.livePlayer .chatBox .noticeChat span img {
  display: block;
  height: 100%;
}
.livePlayer .chatBox .noticeChat .notiMore {
  float: none;
  position: absolute;
  right: -65px;
  bottom: 0;
  display: block;
  width: 60px;
  height: auto;
  background-color: transparent;
  background-image: url('../../assets/img/ico/icon_live_arrow.png');
  background-position: 100% 50%;
  background-size: 20px;
  background-repeat: no-repeat;
  color: #fff;
  text-align: left;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}
.livePlayer .chatBox .chatHistory {
  position: absolute;
  left: 0;
  bottom: 68px;
  overflow-y: auto;
  width: 100%;
  max-height: calc(100% - 253px);
  font-size: 14px;
  line-height: 1.29;
  box-sizing: border-box;
}
.livePlayer .chatBox .chatHistory.active {
  bottom: 50px;
  max-height: 250px;
}
.livePlayer .chatBox .chatHistory .chatDownBtn {
  position: fixed;
  left: 20px;
  bottom: 80px;
  z-index: 12;
  display: none;
  width: 34px;
  height: 24px;
  border-radius: 12px;
  background-color: $main-color;
  background-image: url('../../assets/img/ico/icon_chatdown.png');
  background-position: 50% 50%;
  background-size: 12px 12px;
  background-repeat: no-repeat;
  opacity: 0.8;
}
.livePlayer .chatBox .chatHistory .chatDownBtn.on {
  display: block;
}
.livePlayer .chatBox .chatHistory .chatDownBtn button {
  display: block;
  width: 100%;
  height: 100%;
  background: transparent;
}
.livePlayer .chatBox .chatHistory li {
  overflow-x: hidden;
  width: 100%;
  margin: 3px 0;
  color: #fff;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(0, 0, 0, 0.85);
}
.livePlayer .chatBox .chatHistory li > div {
  display: inline-block;
  width: auto;
  max-width: 100%;
  padding: 2px 5px 1px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.17);
  border-radius: 5px;
}
.livePlayer .chatBox .chatHistory li .chatNick {
  margin-right: 4px;
  color: #fff;
  opacity: 0.8;
}
.livePlayer .chatBox .chatHistory li.me .chatNick {
  color: #ff8000;
}
.livePlayer .chatBox .chatHistory li.ad {
  color: #ffe24d;
}
.livePlayer .chatBox .chatHistory li.ad span {
  overflow: hidden;
  display: inline-block;
  height: 14px;
}
.livePlayer .chatBox .chatHistory li.ad img {
  position: relative;
  top: -2px;
  width: 20px;
  vertical-align: middle;
}
.livePlayer .chatBox .qa .title {
  display: inline-block;
  width: auto;
  height: 28px;
  padding: 0 10px 0 20px;
  box-sizing: border-box;
  border-radius: 14px;
  background-color: rgba(0, 0, 0, 0.2);
  background-image: url('../../assets/img/ico/icon_live_answer2.png');
  background-position: 6px 4px;
  background-size: 20px auto;
  background-repeat: no-repeat;
  line-height: 30px;
  letter-spacing: -0.56px;
}
.livePlayer .chatBox .me .qa .title {
  background-image: url('../../assets/img/ico/icon_live_answer.png');
}
.livePlayer .chatBox .qa .title .nick {
  margin-right: 4px;
  color: #ffe24d;
}
.livePlayer .chatBox .me .qa .title .nick {
  color: #ff8000;
}
.livePlayer .chatBox .qa .param {
  overflow: hidden;
  width: 100%;
  margin-top: 3px;
  padding: 0 0 0 20px;
  box-sizing: border-box;
  background-image: url('../../assets/img/ico/icon_live_reply.png');
  background-position: 0 0;
  background-size: 20px auto;
  background-repeat: no-repeat;
  letter-spacing: -0.56px;
  line-height: 20px;
  box-sizing: border-box;
}
.livePlayer .chatBox .qa .param .cont {
  float: left;
  display: block;
  overflow: hidden;
  width: calc(100% - 80px);
  text-overflow: ellipsis;
  word-wrap: normal;
  white-space: nowrap;
  line-height: inherit;
}
.livePlayer .chatBox .qa .param .ans {
  position: relative;
  top: -2px;
  float: right;
  display: block;
  width: 70px;
  height: auto;
  color: #fff;
  background-color: transparent;
  background-image: url('../../assets/img/ico/icon_live_arrow.png');
  background-position: 100% 50%;
  background-size: 20px auto;
  background-repeat: no-repeat;
  text-align: left;
  text-shadow: inherit;
  line-height: inherit;
  outline: none;
}

.livePlayer .chatBox form {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 15;
  overflow: hidden;
  display: block;
  width: calc(100% - 152px);
  height: 44px;
  margin-left: 60px;
  padding-bottom: 14px;
}
.livePlayer .chatBox form.full {
  width: 100%;
  margin-left: 0;
}
.livePlayer .chatBox .hiddenBtn {
  position: fixed;
  left: 10px;
  bottom: 16px;
  z-index: 17;
  display: block;
  width: 40px;
  height: 40px;
  outline: none;
}
.livePlayer .chatBox .hiddenBtn.show {
  background: url('../../assets/img/ico/icon_live_hiddenBtnV.png') 0 0 / 40px
    40px no-repeat;
}
.livePlayer .chatBox .hiddenBtn.hide {
  background: url('../../assets/img/ico/icon_live_hiddenBtn.png') 0 0 / 40px
    40px no-repeat;
}

.livePlayer .chatBox input {
  float: left;
  display: block;
  width: 100%;
  height: 44px;
  padding: 0 10px;
  border: 1px solid #fff;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.2);
  font-size: 16px;
  color: #fff;
  box-sizing: border-box;
  outline: none;
}
.livePlayer .chatBox .hide input {
  display: none;
}
.livePlayer .chatBox button {
  display: none;
  float: left;
  width: 70px;
  height: 44px;
  background: #fff;
  color: #408ef7;
}
.livePlayer .chatBox button.disabled {
  color: #a7a7a7;
}
.livePlayer .chatBox input:-ms-input-placeholder {
  color: #fff;
}
.livePlayer .chatBox input::placeholder {
  color: #fff;
}
.livePlayer .chatBox input::-webkit-input-placeholder {
  color: #fff;
}

.livePlayer .chatBox.chatting {
  z-index: 11;
}
.livePlayer .chatBox.chatting form {
  padding-bottom: 0;
}
.livePlayer .chatBox.chatting .hiddenBtn {
  display: none;
}
.livePlayer .chatBox input:focus,
.livePlayer .chatBox.chatting input {
  float: left;
  width: calc(100% - 70px);
  border-radius: 0;
  margin-left: 0;
  background: #fff;
  color: #191919;
}
.livePlayer .chatBox input:focus + button,
.livePlayer .chatBox.chatting input + button {
  display: block;
}
.livePlayer .chatBox input:focus:-ms-input-placeholder,
.livePlayer .chatBox.chatting input:focus:-ms-input-placeholder {
  color: #a7a7a7;
}
.livePlayer .chatBox input:focus::placeholder,
.livePlayer .chatBox.chatting input:focus::placeholder {
  color: #a7a7a7;
}
.livePlayer .chatBox input:focus::-webkit-input-placeholder,
.livePlayer .chatBox.chatting input:focus::-webkit-input-placeholder {
  color: #a7a7a7;
}

.pVodWrap.live .pVodInner .pVodTop.hide,
.pVodWrap.live .pVodInner .brandImg.hide,
.pVodWrap.live .pVodInner .pVodSoundDiv.hide,
.pVodWrap.live .pVodInner .pVodProduct.hide,
.pVodWrap.live .pVodInner .pVodAsk.hide,
.livePlayer .chatBox.hide,
.pVodWrap.live .fp-ui,
.pVodWrap.live .vjs-big-play-button {
  display: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.shareBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  opacity: 0;
  transition: all 0.3s 0.1s ease;
}
.shareBox .modalWrap {
  transform: translateY(calc(-50% + 50px));
  transition: all 0.3s 0.1s ease;
}
.shareBox.on {
  z-index: 20;
  opacity: 1;
}
.shareBox.on .modalWrap {
  transform: translateY(-50%);
}
.pipMod .shareBox {
  display: none;
}

.chatBox.chatting .noticeChat,
.chatBox.chatting .marketingChat,
.chatBox.chatting .prdtPined {
  display: none;
}
.livePlayer .backPannel {
  display: none;
}

.livePlayer .active ~ .backPannel {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 19;
  display: block;
  width: 100%;
  height: 100%;
}

#vodPipPlayer .fp-error {
  display: none;
}

// 가위바위보 게임
.pVodWrap.live {
  .hideFilter {
    .gameConfirm,
    .gameButtons {
      display: none;
    }
  }

  .game_noti {
    position: absolute;
    top: 20px;
    left: 144px;
    z-index: 5;
    color: #ffe24d;
  }

  .gameConfirm {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 8;
    width: 260px;
    transform: translate(-50%, -50%);
    text-align: center;
    transition: all 0.4s ease;

    p {
      font-size: 24px;
      color: #ff007f;
      text-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
    }
    .btns {
      margin-top: 40px;
      width: 100%;
      font-size: 0;

      button {
        width: 80px;
        margin-left: 20px;
        &:first-child {
          margin-left: 0;
        }

        img {
          display: block;
          width: 100%;
        }
      }
    }
  }

  .gameButtons {
    transition: all 0.4s ease;

    .sellover {
      position: absolute;
      top: 100px;
      right: 10px;
      z-index: 5;

      .iconBox {
        text-align: center;

        img {
          display: block;
          width: 60px;
          height: 60px;
          margin: 0 auto;
        }
        p {
          margin-top: 4px;
          color: #ff007f;
          font-size: 12px;
        }
      }
    }

    .buttons {
      position: absolute;
      top: 50%;
      right: 20px;
      z-index: 5;
      transform: translateY(-50%);

      button {
        display: block;
        width: 50px;
        height: 50px;
        margin: 15px 0;

        img {
          display: block;
          width: 100%;
        }
      }
    }

    .centerBox {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 6;
      max-width: 80%;
      font-size: 30px;
      font-weight: 700;
      color: #ff007f;
      text-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
      text-align: center;
      line-height: 1.4;
      transform: translate(-50%, -50%);
      &.gameovered {
        z-index: 8;
      }

      .selectedBox {
        width: 120px;
        height: 120px;
        margin: 20px auto;

        img {
          width: 100%;
        }
      }
      .info {
        font-size: 14px;
        font-weight: 400;
      }

      .gameover {
        width: 100%;
        text-align: center;

        img {
          width: 100%;
          height: auto;
        }
        span {
          display: inline-block;
          margin-top: 10px;
          color: #ff007f;
          font-size: 18px;
          font-weight: 400;
          text-decoration: underline;
        }
      }

      .winBox {
        width: 140%;
        margin-left: -20%;

        img {
          width: 100%;
          height: auto;
        }

        .nickName {
          color: #ff007f;
          font-size: 20px;
        }
      }
    }
  }
  .liveCoupon {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 8;
    display: block;
    width: 70%;
    max-width: 260px;
    font-size: 30px;
    font-weight: 700;
    color: #ff007f;
    text-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
    text-align: center;
    line-height: 1.4;
    transform: translate(-50%, -50%);

    .txt_get {
      font-size: 18px;
      font-weight: 400;
      line-height: 1.6;
      text-align: center;
      text-decoration: underline;
    }

    .couponBox {
      position: relative;
      width: 100%;

      img {
        width: 100%;
        height: auto;
      }

      .couponName {
        overflow: hidden;
        position: absolute;
        top: 30%;
        left: 0;
        z-index: 4;
        width: 100%;
        padding: 0 10px;
        color: #fff;
        text-align: center;
        box-sizing: border-box;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-wrap: normal;
      }
    }

    .info {
      font-size: 18px;
      font-weight: 400;
      line-height: 1.6;
      text-align: center;
    }
  }
}
.pipMod .gameButtons {
  right: -100px;
  opacity: 0;
}
.pipMod .gameConfirm {
  left: calc(50% + 100px);
  opacity: 0;
}

.live .pVodInner .video-js {
  height: 100%;
}
.live .pVodInner .video-js .vjs-tech {
  height: 100%;
}
</style>